import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { getCommonStyles } from '@utils'
import { Skeleton } from './Skeleton'
import { MessageBubbleSkeletonList } from './MessageBubbleSkeleton'
import { NoteItemSkeletonList } from './NoteItemSkeleton'

export const ConversationWithNotesSkeleton: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const commonStyles = getCommonStyles(theme)

  return (
    <View style={[commonStyles.rowNoGap, commonStyles.fullHeight, commonStyles.alignStart]}>
      {/* Chat à gauche */}
      <View style={[commonStyles.flex, commonStyles.fullHeight]}>
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Skeleton width={40} height={40} borderRadius={20} />
            <View style={[styles.onlineIndicator, { backgroundColor: theme.colors.grey }]} />
          </View>
          <View style={styles.headerText}>
            <Skeleton width="60%" height={16} borderRadius={4} style={styles.nameSkeleton} />
            <Skeleton width="40%" height={12} borderRadius={4} />
          </View>
        </View>
        <View style={styles.conversationContent}>
            <MessageBubbleSkeletonList count={10} />
            <View style={styles.inputContainer}>
              <View style={styles.inputWrapper}>
                <Skeleton width="70%" height={20} borderRadius={10} style={{ marginRight: theme.spacing.sm }} />
                <Skeleton width={40} height={40} borderRadius={20} />
              </View>
              <Skeleton width={50} height={50} borderRadius={25} />
            </View>
        </View>
      </View>
      {/* Notes à droite */}
      <View style={[commonStyles.flex350, commonStyles.fullHeight]}>
        <View style={styles.notesContainer}>
          <View style={styles.tabsContainer}>
            <View style={styles.tab}>
              <Skeleton width={80} height={16} borderRadius={4} />
            </View>
            <View style={styles.tab}>
              <Skeleton width={60} height={16} borderRadius={4} />
            </View>
          </View>
          <View style={styles.buttonContainer}>
            <Skeleton width={200} height={40} borderRadius={20} />
          </View>
          <NoteItemSkeletonList count={5} />
        </View>
      </View>
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: theme.spacing.md,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.grey,
    },
    headerLeft: {
      position: 'relative',
      marginRight: theme.spacing.md,
    },
    onlineIndicator: {
      position: 'absolute',
      bottom: 2,
      right: 2,
      width: 10,
      height: 10,
      borderRadius: 5,
      borderWidth: 2,
      borderColor: theme.colors.white,
    },
    headerText: {
      flex: 1,
    },
    nameSkeleton: {
      marginBottom: theme.spacing.xs,
    },
    conversationContent: {
      flex: 1,
      justifyContent: 'flex-end',
      overflow: 'hidden',
    },
    inputContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
    },
    inputWrapper: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-end',
      backgroundColor: theme.colors.grey,
      borderRadius: 25,
      paddingHorizontal: theme.spacing.xs,
      paddingVertical: theme.spacing.xs,
      marginRight: theme.spacing.sm,
      minHeight: 40,
    },
    notesContainer: {
      padding: theme.spacing.lg,
    },
    tabsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingBottom: theme.spacing.sm,
    },
    tab: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingBottom: theme.spacing.sm,
      borderBottomWidth: 2,
      borderBottomColor: theme.colors.grey20,
    },
    buttonContainer: {
      alignItems: 'center',
      marginTop: theme.spacing.sm,
      marginHorizontal: theme.spacing.lg,
    },
  })

